import _ from '../../common/utility';

function digitalHub() {
	//Highlight current page url
	$('main.resp-container.digital_hub .hp_resource-center ul li').each(function () {
		if ($(this).find('a').attr('href') === window.location.pathname) {
			$(this).addClass('selected');
		}
	});

	//On page load horizontally scroll to the active item in the overflow div of multi-nav component
	const el = document.querySelector('main.resp-container.digital_hub .hp_resource-center ul li.selected');
	if (el) {
		scrollTo(el);
	}

	//logo scaling if logo is present
	const logoEl = document.querySelector('main.resp-container.digital_hub .hp_banner_sponsored div.sponsored-logo img');
	if (logoEl) {
		scaleLogo(logoEl);
	}

	padMe();
}

// Scroll horizontally fn()
function scrollTo(el) {
	const elLeft = el.offsetLeft + el.offsetWidth;
	const elParentLeft = el.parentNode.offsetLeft + el.parentNode.offsetWidth;

	// check if element not in view
	if (elLeft >= elParentLeft + el.parentNode.scrollLeft) {
		el.parentNode.scrollLeft = elLeft - elParentLeft + 2;
	} else if (elLeft <= el.parentNode.offsetLeft + el.parentNode.scrollLeft) {
		el.parentNode.scrollLeft = el.offsetLeft - el.parentNode.offsetLeft;
	}
}

function scaleLogo(image) {
	// Create a new Image object and set its source to the original image source
	const tempImage = new Image();
	tempImage.src = image.src;

	tempImage.onload = function () {
		const maxWidth = 150; // Define the maximum width you want for the scaled image
		const maxHeight = 50; // Define the maximum height you want for the scaled image

		let width = tempImage.naturalWidth; // Get the original width of the image
		let height = tempImage.naturalHeight; // Get the original height of the image

		let ratio = 0;
		// Check if the current width is larger than the max
		if (width > maxWidth) {
			ratio = maxWidth / width; // get ratio for scaling image
			image.width = maxWidth;
			image.height = height * ratio;

			width = width * ratio; // Reset width to match scaled image
			height = height * ratio; // Reset height to match scaled image
		}

		// Check if current height is larger than max
		if (height > maxHeight) {
			ratio = maxHeight / height; // get ratio for scaling image
			image.width = width * ratio;
			image.height = maxHeight;

			width = width * ratio; // Reset width to match scaled image
			height = height * ratio; // Reset height to match scaled image
		}

		image.style.display = 'inline';
		// console.log("new dimensions-x2: " + width + "x" + height + "x-ratio:" + ratio);
	};
}

function padMe() {
	const articleSection = document.querySelectorAll('main.resp-container.digital_hub .hp_bucket2col');
	const infoSection = document.querySelectorAll('main.resp-container.digital_hub .hp_manual2col');
	if (articleSection.length === 0 && infoSection.length > 0) {
		infoSection[0].classList.add('padme');
	}
}

export default _.catch(digitalHub);
